import { useAuth } from "@/components/auth/use-auth";
import { Spin } from "antd";
import { Navigate } from "react-router-dom";

type Props = {
	children: React.ReactNode;
};
export default function LoginAuthGuard({ children }: Props) {
	const { user, loading } = useAuth();

	if (loading) {
		return <Spin size="large" className="flex-center h-screen" />;
	}

	if (!user) {
		return <Navigate to="/login" replace />;
	}

	return <>{children}</>;
}
